import type { Translations } from "../types";

const fr: Translations = {
  "meta.title": "Carte des clics par pays",
  "meta.description":
    "Carte du monde interactive : clics gratuits par pays ainsi que soutien payant via Stripe, PayPal et Buy Me a Coffee.",

  "app.title": "Carte des clics par pays",

  "map.intro":
    "Cliquez sur un pays sur la carte pour lui donner un vote gratuit, ou envoyez-lui un soutien financier - les deux comptent pour le classement combiné ci-dessous. La carte ne reflète que le soutien au sein de cette application, pas la richesse nationale réelle ni le PIB.",
  "map.verifying": "Vérification …",
  "map.confirmNotRobot": "Avant de pouvoir ajouter des clics gratuits, confirmez rapidement que vous n'êtes pas un robot :",
  "map.tryAgain": "Réessayer",
  "map.registeringClick": "Enregistrement du clic …",
  "map.selectedCountry": "Pays sélectionné : {name}.",
  "map.selectFirstFeedback": "Pays sélectionné. Pour ajouter un clic gratuit, confirmez d'abord ci-dessous que vous n'êtes pas un robot.",
  "map.verificationExpired": "La vérification a expiré - confirmez à nouveau que vous n'êtes pas un robot.",
  "map.slowDown": "Un peu plus lentement - attendez un instant avant votre prochain clic.",
  "map.clickFailed": "Impossible d'enregistrer le clic. Veuillez réessayer.",
  "map.clickErrorGeneric": "Erreur lors de l'enregistrement du clic.",
  "map.leaderboardHeading": "Classement des pays",
  "map.emptySelection": "Sélectionnez un pays sur la carte pour voter ou le soutenir.",
  "map.loadingData": "Chargement des données …",

  "worldmap.loadError": "Impossible de charger la carte.",
  "worldmap.resetZoom": "Réinitialiser le zoom",
  "worldmap.resetButton": "⤾ Réinitialiser",
  "worldmap.loadingMap": "Chargement de la carte …",
  "worldmap.unknownCountry": "Inconnu",
  "worldmap.ariaClicks": "{name} : {clicks} clics",
  "worldmap.tooltipClicks": "{clicks} clics",

  "legend.fewer": "Moins de clics",
  "legend.more": "Plus de clics",

  "list.empty": "Pas encore de clics. Soyez le premier !",
  "list.ariaLabel": "Classement des pays par clics",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY n'est pas défini - voir le README pour la configuration.",
  "human.verificationFailedGeneric": "Échec de la vérification.",
  "human.networkError":
    "Impossible de joindre la vérification (erreur réseau) - vérifiez VITE_SUPABASE_URL, que verify-human est déployé, et ALLOWED_ORIGIN ; voir README/NAVODILA.",
  "human.verificationFailedRetry": "Échec de la vérification, réessayez.",

  "provider.stripe": "💳 Carte (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Pays sélectionné",
  "panel.currentlyRanked": "Actuellement classé #{rank}",
  "panel.shareCopied": "Copié ✓",
  "panel.shareShared": "Partagé ✓",
  "panel.shareButton": "🔗 Partager",

  "panel.tableClicks": "Clics",
  "panel.tableFree": "Gratuit",
  "panel.tablePaid": "Payant",
  "panel.rowAllTime": "Depuis le début",
  "panel.rowThisYear": "Cette année",
  "panel.rowThisWeek": "Cette semaine",
  "panel.rowToday": "Aujourd'hui",

  "panel.totalCombined": "Total combiné :",
  "panel.totalSupport": "Soutien total :",

  "panel.paymentMethod": "Moyen de paiement",
  "panel.noPaymentMethod": "Aucun moyen de paiement n'est disponible actuellement.",
  "panel.supportAmount": "Montant du soutien (EUR)",
  "panel.amountRange": "Le montant doit être compris entre {min} et {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Clics payants estimés :",
  "panel.ratioInfo":
    "Ratio : {a} = {b} clics (p. ex. {c} = {d} clics). Il ne s'agit que d'une estimation avant paiement - le nombre final de clics est toujours calculé et confirmé par le serveur en fonction du paiement réellement confirmé.",
  "panel.preparing": "Préparation …",
  "panel.continueWith": "Continuer avec {provider}",
  "panel.choosePaymentMethod": "Choisissez un moyen de paiement",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME n'est pas défini - voir le README pour la configuration.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID n'est pas défini - voir le README pour la configuration.",

  "panel.paypalAmountInfo": "Montant : {amount} (estimé à {clicks} clics). Terminez le paiement avec le bouton PayPal ci-dessous.",
  "panel.back": "← Retour",

  "panel.bmcWarningTitle": "⚠️ Avant de continuer vers BuyMeCoffee :",
  "panel.bmcWarningBody":
    "Collez le code ci-dessous dans le champ message/note lors du paiement — c'est le seul moyen pour nous de savoir quel pays vous soutenez. Sans ce code, nous ne pouvons attribuer le paiement à aucun pays.",
  "panel.copy": "Copier",
  "panel.copied": "Copié ✓",
  "panel.suggestedAmount": "Montant suggéré :",
  "panel.bmcAmountNote":
    "(estimé à {clicks} clics). BuyMeCoffee ne permet malheureusement pas de transmettre le montant via le lien — saisissez-le ou sélectionnez-le vous-même sur leur site. Le nombre réel de clics est toujours calculé à partir du montant que vous envoyez réellement sur BuyMeCoffee, et non de cette estimation.",
  "panel.openBmc": "Ouvrir BuyMeCoffee et continuer →",
  "panel.waitingProvider": "En attente de la confirmation de paiement du prestataire de paiement …",
  "panel.waitingConfirmation": "En attente de la confirmation de paiement …",
  "panel.timedOut":
    "Le délai de vérification est écoulé. Si vous avez effectué le paiement, la carte se mettra à jour dès que le serveur recevra la confirmation - cela peut parfois prendre un peu plus de temps.",
  "panel.checkAgain": "Vérifier à nouveau",

  "panel.cancelled": "Le paiement a été annulé ou n'a pas abouti. La carte n'a pas changé.",
  "panel.tryAgain": "Réessayer",

  "panel.confirmed": "✅ Soutien confirmé !",
  "panel.confirmedBody": "{country} a reçu {clicks} clics payants pour {amount}.",

  "panel.errorPreparingSupport": "Erreur lors de la préparation de votre soutien.",
  "panel.errorPreparingPayment": "Erreur lors de la préparation du paiement.",
  "panel.errorConfirmingPayment": "Erreur lors de la confirmation du paiement.",
  "panel.errorPayingPaypal": "Erreur lors du paiement avec PayPal.",

  "share.unranked": "{flag}{country} a besoin de votre soutien sur la carte du monde !\nAidez-le à grimper dans le classement 👇",
  "share.rank1": "{flag}{country} est actuellement #1 !\nAidez-nous à rester au sommet 👇",
  "share.rankN": "{flag}{country} est actuellement #{rank} !\nAidez-nous à atteindre la #1 👇",

  "language.switcherLabel": "Langue",
};

export default fr;
